import React from 'react';
import { WidgetProps } from '@rjsf/utils';

import { Autocomplete, TextField } from '@mui/material';

interface OptionType {
    label: string,
    value: string
}

const CustomAutocomplete: React.FC<WidgetProps> = ({ id, options, value, required, disabled, readonly, onChange, label }) => {

    const handleChange = (event: any, newValue: string) => {
        const selectedValue = newValue;
        console.log("selected value in autocomplete: ", selectedValue)
        onChange(selectedValue);
    };

    const items: OptionType[] = options.enumOptions as unknown as OptionType[];

    return (
        <Autocomplete
            id={id}
            value={value || null}
            onChange={handleChange}
            options={items.map(item => item.value)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label || "Select an option"}
                    variant="outlined"
                    required={required}
                    disabled={disabled || readonly}
                />
            )}
            disableClearable={required}
        />
    )
}

export default CustomAutocomplete;
